import { FormQuerySelector } from "@vesatogo/grass-core"
import { FormCard } from "~/components/FormCard"
import SharedEntityGroup from "~/constants/SharedEntityGroup"
import { useAllDepotsQuery, useAllUsersQuery } from "~/generated/graphql"

export const WhoOverseesProduction = ({
  inputProps,
  isFinal,
}: {
  inputProps: any
  isFinal: boolean
}) => {
  const productionOfficer = ["Production Officer"]
  return (
    <FormCard title="Who oversees Production">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <FormQuerySelector
          required={true}
          label={isFinal ? "PM Incharge" : "Production Officer"}
          className={"mb-2"}
          serverSideQuery
          dataHook={useAllUsersQuery}
          variables={{ groups: productionOfficer }}
          {...inputProps("officer", {
            group: SharedEntityGroup.KiteUser,
          })}
        />
        <FormQuerySelector
          label="Production Depot"
          placeholder="Select"
          required
          dataHook={useAllDepotsQuery}
          serverSideQuery
          useWildCardsInQuery={false}
          {...inputProps("depot", {
            group: SharedEntityGroup.StarlingDepot,
          })}
        />
      </div>
    </FormCard>
  )
}
